import { anyType } from "../types";

/**********
 * レイヤー名からショートIDを取得する
 **********/ 
export function encodeLayerList(layerList: string[], menuData: anyType) {
    if(!menuData || layerList.length === 0) { return ''; }
    const menuItems = [...walkCategories(menuData)]
    const url = layerList.map((layer: string) => {
        const target = menuItems.find((item: anyType) => item.id === layer);
        return target ? target.shortId : '';
    }).join('');
    return url;
}

/**********
 * ショートIDからレイヤー名を取得する
 **********/ 
export function decodeLayerList(url: string, menuData: anyType) {
    if(!menuData || url === '') { return []; }
    const menuItems = [...walkCategories(menuData)]
    const layerList = menuItems.filter((item: anyType) => url.includes(item.shortId)).map((item: anyType) => item.id);
    return layerList;
}

export function* walkCategories(data: {[key: string]: anyType }): Generator<anyType, void, unknown> {
    for (const x in data) {
        if ('items' in data[x]) {
            yield* walkCategories(data[x].items);
        } else {
            yield data[x];
        }
    }
};
